import { RouterProvider } from "react-router";

import router from "@/router/index";
import { Toaster } from "@/components/ui/toaster";
import { OrganizationProvider } from "@/components/providers/OrganizationProvider";
import { useBodyPointerEventsGuard } from "@/hooks/useBodyPointerEventsGuard";

import "./App.css";

function App() {
  // Sits above the router so it survives every navigation (MSMS-53).
  useBodyPointerEventsGuard();

  return (
    <OrganizationProvider>
      <RouterProvider router={router} />
      <Toaster />
    </OrganizationProvider>
  );
}

export default App;
